import { Box, HStack, Img, VStack } from "@chakra-ui/react";

export function FormBgContainer({ children }: { children: React.ReactNode }) {
  return (
    <VStack alignItems={"stretch"} position="relative">
      <Box position="absolute" overflow="hidden" left="0px" right="0px" top="0px" bottom="0px" zIndex="-10">
        <Img src="/background.jpg" position="absolute" width="2000px" maxWidth="2000px" top="-600px" left="0px" />
      </Box>

      <HStack padding={8} paddingX={16} gap={8}>
        {children}
        <Img src="/RinconSeal.png" h="100%" w="200px" />
      </HStack>
    </VStack>
  );
}
